<template>
  <!-- Product Number Or Serial number -->
  <div class="mb-2">
    <h1>
      {{ $t("functionControlRefferalform") }}
    </h1>
    <hr />
    <b-form @submit.prevent="search">
      <b-row class="no-mar">
        <b-col md="6">
          <b-form-group :label="$t('productNumberOrSerialNumber')">
            <b-form-input
              v-model="searchTerm"
              :placeholder="$t('enterYourName')"
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col md="6">
          <b-form-group :label="$t('yourEmailaddress')">
            <b-form-input
              v-model="emailAddress"
              :placeholder="$t('enterYourEmailAddress')"
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col md="6"></b-col>

        <b-col cols="12">
          <b-button v-if="searchTerm && emailAddress" type="submit">{{
            $t("search")
          }}</b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-form v-if="product.productID" @submit.prevent="submit">
      <b-row class="no-mar">
        <b-col lg="6">
          <function-control-product
            v-model="product"
            class="mb-2"
            :productid="product.productID"
            :itemdescription="product.description"
            :productright="product.rfc"
            :productleft="product.lfc"
            :options="options"
          />
        </b-col>
      </b-row>

      <div v-if="!product.productID">
        <p>
          {{ $t("theProvidedProductIsNotReadyForARefferalformFuncti") }}
        </p>
      </div>
      <hr />
      <b-button
        v-if="product.productID"
        type="submit"
        class="btn btn-primary"
        >{{ $t("submit") }}</b-button
      >
    </b-form>
  </div>
</template>

<script>
import FunctionControlProduct from "./FunctionControlProduct"
import {
  BForm,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue"
import {
  getRefferalProduct,
  getRefferalProductOptions,
  saveRefferalProduct,
} from "../../services/refferal"
export default {
  components: {
    FunctionControlProduct,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      product: {},
      data: {},
      options: {},
      searchTerm: "",
      emailAddress: "",
    }
  },
  computed: {
    customerID() {
      return this.$store.state.customerID
    },
  },
  async created() {
    const customerField = document.getElementsByName("customerid")

    this.$store.commit("setCustomerID", { customerID: customerField[0].value })
    this.options = await getRefferalProductOptions()
  },
  methods: {
    async search() {
      const result = await getRefferalProduct({
        email: this.emailAddress,
        searchTerm: this.searchTerm,
      })

      if (result.message) {
        this.$toasted.show(result.message)
        return
      }

      this.product = result
      this.product.audicienCustomerID = this.customerID
    },
    async submit() {
      
      await new Promise((resolve) => setTimeout(resolve, 0))
      const result = await saveRefferalProduct({
        product: this.product,
      })

      if (result.message) {
        this.$toasted.show(result.message)
      }

      if (result.success) {
        this.product = {}
        this.searchTerm = ""
        this.emailAddress = ""
      }
    },
  },
}
</script>

<style scoped>
h1 {
  text-transform: capitalize;
  font-size: 1.5625rem;
  margin-top: 0;
}
pre {
  white-space: pre-wrap;
}
pre {
  overflow-x: auto;
}
hr {
  clear: both;
  max-width: 100%;
}
</style>
